import { includes, propOr } from 'ramda';

import {
  LOAD_PAGINATED_QUERY_FAILURE,
  LOAD_PAGINATED_QUERY_REQUEST,
  LOAD_PAGINATED_QUERY_SUCCESS,
  PAGINATION_RESET,
} from '../actions/prismic';
import { path, pathOr } from '../helpers/compact';

/**
 * @typedef {Object} Pager
 * @property {number} count
 * @property {number} page
 * @property {boolean} isLoading
 * @property {hasReachedEnd} isLoading
 * @property {any} error
 * @property {Array.<any>} result
 */

export const defaultPager: Pagination = {
  isLoading: false,
  hasReachedEnd: false,
  error: null,
  result: {},
  context: {},
};

const pagination = (state = defaultPager, action: any): Pagination => {
  switch (action.type) {
    case LOAD_PAGINATED_QUERY_REQUEST:
      return {
        ...state,
        isLoading: true,
      };

    case LOAD_PAGINATED_QUERY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        hasReachedEnd: !!action.end,
        result: {
          ...propOr({}, 'result', state),
          [path('context.page', action)]: pathOr([], 'payload.result', action),
        },
        context: action.context,
      };

    case LOAD_PAGINATED_QUERY_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case PAGINATION_RESET:
      return defaultPager;

    /* istanbul ignore next */
    default:
      return state;
  }
};

const localizePaginations = (
  state: PaginationGroup = {},
  action: any
): PaginationGroup => {
  if (
    includes(action.type, [
      PAGINATION_RESET,
      LOAD_PAGINATED_QUERY_REQUEST,
      LOAD_PAGINATED_QUERY_SUCCESS,
      LOAD_PAGINATED_QUERY_FAILURE,
    ])
  ) {
    return {
      ...state,
      [action.key]: pagination(state[action.key], action),
    };
  }

  return state;
};

const paginations = (
  state: PaginationsState = {},
  action: Record<string, any>
): PaginationsState => {
  if (action.lang) {
    return {
      ...state,
      [action.lang]: localizePaginations(state?.[action.lang], action),
    };
  }
  return state;
};

export type Pagination = {
  isLoading: boolean;
  hasReachedEnd: boolean;
  error: any;
  result: any;
  context: any;
};

export type PaginationGroup = Record<string, Pagination>;
export type PaginationsState = Record<string, PaginationGroup>;

export default paginations;
